import axios from '@/plugins/axios';

export const getAvailableServiceList = () => {
    return axios.get('subscriptions/v2/services/list')
}

export const getUserServiceList = () => {
    return axios.get('subscriptions/v2/user/subscription/list')
}


export const discountServiceList = () => {
    return axios.get('subscriptions/v2/discount/list')
}

export async function topUp(
    amount, id = 0,
    services = []) {
    return await axios.post('subscriptions/v2/payment/topUp', {
        amount: amount,
        user_id: id,
        services: services
    });
}

export async function buySubscription(
    amount, id = 0,
    discountSize = 0,
    discount = 0,
    balance = 0,
    pricePerUser = 0,
    pricePerOrg = 0,
    fullCost = 0) {
    return await axios.post('subscriptions/withdraw', {
        amount: amount,
        user_subscription_id: id,
        discountSize: discountSize,
        discount: discount,
        balance: balance,
        pricePerUser: pricePerUser,
        pricePerOrg: pricePerOrg,
        fullCost: fullCost
    });
}

export async function createInvoice(
    invoice, amount, userId,
    discountSize = 0,
    discount = 0,
    balance = 0,
    pricePerUser = 0,
    pricePerOrg = 0,
    fullCost = 0) {
    invoice.discountSize = discountSize
    invoice.discount = discount
    invoice.balance = balance
    invoice.pricePerUser = pricePerUser
    invoice.pricePerOrg = pricePerOrg
    invoice.fullCost = fullCost
    return await axios.post('subscriptions/createInvoice', {
        invoice: invoice,
        amount: amount,
        userId: userId
    })
}

export async function getInvoiceDetails() {
    return await axios.get('subscriptions/v2/invoice/details');
}

export async function balance() {
    return await axios.get('subscriptions/balance');
}

export async function getInvoices(page = 1, perPage = 10) {
    return await axios.post('subscriptions/v2/invoice/user', {perPage: perPage, page: page});
}

export async function downloadInv(id) {
    return await axios.get('subscriptions/invoice/' + id, {responseType: 'blob'})
}


export async function getSubscription(id) {
    return await axios.get('subscriptions/v2/user/subscription/' + id)
}

export async function saveOrgs(data) {
    console.log(data)
    return await axios.post('subscriptions/v2/user/subscription/' + data.subscription_id + '/saveOrgs', data);
}